import { RafEtiket } from './../../models/RafEtiket';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Database } from '../database';


@Injectable()
export class Blletiket extends Database {
  constructor() {
    super("RafEtiket");

  }
  rafetiketkle(ID: number, ItemsRef: number, Name: string, Barcode1: string, Barcode2: string, Price1: number, Price2: number,
    Price3: number, Price4: number, FiyatDegisimTarihi: string, UlkeAdi: string, BirimAdi: string, Miktar: number) {

    return new Promise((resolve, reject) => {
      this.getAll({StokKartiID: ItemsRef }).then(b => {
        var sonuc = <any>b;

        if (sonuc.length > 0) {
          sonuc[0].Miktar = sonuc[0].Miktar + parseFloat(Miktar.toString());
          this.miktarGuncelle(sonuc[0]).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
        else {
          var etiketdetay = new RafEtiket();
          etiketdetay.StokKartiID = ItemsRef;
          etiketdetay.StokAdi = Name;
          etiketdetay.Barcode1 = Barcode1;
          etiketdetay.Barcode2 = Barcode2;
          etiketdetay.Price1 = Price1;
          etiketdetay.Price2 = Price2;
          etiketdetay.Price3 = Price3;
          etiketdetay.Price4 = Price4;
          etiketdetay.FiyatDegisimTarihi = FiyatDegisimTarihi;
          etiketdetay.UlkeAdi = UlkeAdi;
          etiketdetay.BirimAdi = BirimAdi;
          etiketdetay.Miktar = Miktar;
          etiketdetay.ID = -1;
          this.add(etiketdetay).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        }
      });
    });
  }

  etiketlistesi_temp() {

  }
  miktarGuncelle(detay: RafEtiket) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update RafEtiket set Miktar = ? where ID = ?", [detay.Miktar, detay.ID]).then(a => {
        res(a);
      }).catch(x => {
        err(x);
      })

    })
  }






}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-etiket.ts